import React, { Fragment, useRef, useState } from 'react';

export default function RawInput({
  ...inputProps
}: {
  name: string;
  required?: boolean;
  label: string;
} & React.InputHTMLAttributes<HTMLInputElement>): JSX.Element {
  // if input already has value it is not empty
  const [isEmpty, setIsEmpty] = useState(!inputProps.value);
  const [isDirty, setIsDirty] = useState(false);
  const inputElement = useRef<HTMLInputElement>(null);
  const showIsRequiredError = inputProps.required && isEmpty && isDirty;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setIsDirty(true);
    setIsEmpty(!event.target?.value);
    if (inputProps.onChange) {
      inputProps.onChange(event);
    }
  };

  return (
    <Fragment>
      <label
        htmlFor={inputProps.name}
        className='font-medium leading-5 mb-1.2 text-sm'
      >
        {inputProps.label}
      </label>
      <input
        {...inputProps}
        onChange={onChange}
        ref={inputElement}
        name={inputProps.name}
        id={inputProps.id}
        className='border border-slate-300 text-sm rounded-lg block w-full p-2.5'
      />
      {showIsRequiredError && (
        <span className='text-red-600 text-md'>is required.</span>
      )}
    </Fragment>
  );
}
